import { Button } from 'devextreme-react/button';
import { Popover } from 'devextreme-react/popover';
import { useNavigate } from 'react-router-dom';
import { ActionRequiredCardProps } from '../types/ActionRequiredCardProps';
import './ActionRequiredCard.scss';
import ActiveOrdersActiveIcon from '../../../../assets/dashboard/Active Orders - Active.svg';
import ActiveOrdersInactiveIcon from '../../../../assets/dashboard/Active Orders - Inactive.svg';
import PendingOrdersActiveIcon from '../../../../assets/dashboard/Pending Orders - Active.svg';
import PendingOrdersInactiveIcon from '../../../../assets/dashboard/Pending Orders - Inactive.svg';
import PastDueOrdersActiveIcon from '../../../../assets/dashboard/Past Due Orders - Active.svg';
import PastDueOrdersInactiveIcon from '../../../../assets/dashboard/Past Due Orders - Inactive.svg';

export default function ActionRequiredCard(props: ActionRequiredCardProps) {

    let navigate = useNavigate();

    var statDataItem = props.statData.find(x => x.statID === props.statID);
    const infoElementID = "ar-info-" + props.statID;
    const orderPluralCaption = props.statID < 100 ? "Leads" : "Orders";
    const totalCount = statDataItem?.total ?? 0;
    const activeCount = statDataItem?.active ?? 0;
    const pendingCount = statDataItem?.pending ?? 0;
    const pastDueCount = statDataItem?.pastDue ?? 0;
    const pendingStatusCount = statDataItem?.pendingStatus ?? 0;

    return (
        <div className={'ar-button dx-card' + (!props.showPending && !props.showPendingPlaceholder ? ' ar-button-no-pending' : '')}>
            <div className='ar-text ar-text-multiline'>{props.text}</div>
            <div className='ar-total'>
                <span>{totalCount}</span>
                {
                    props.description &&
                    <i className='dx-icon dx-icon-Inscyth-Info' id={infoElementID}></i>
                }
            </div>
            {
                props.description &&
                <Popover
                    target={'#' + infoElementID}
                    showEvent='dxhoverstart'
                    hideEvent='dxhoverend'
                    width={300}
                >
                    {props.description}
                </Popover>
            }
            <>
                <Button
                    onClick={() => navigate(props.url + '?active=true')}
                    className={activeCount > 0 ? "active-orders-button" : ""}>
                    <img src={activeCount > 0 ? ActiveOrdersActiveIcon : ActiveOrdersInactiveIcon}></img>
                    <div className="button-text">
                        Active {orderPluralCaption}<br />
                        <b>{activeCount}</b>
                    </div>
                </Button>
                {
                    props.showPending &&
                    <Button onClick={() => navigate(props.url + '?pending=true')}
                        className={pendingCount > 0 ? "pending-orders-button" : ""}>
                        <img src={pendingCount > 0 ? PendingOrdersActiveIcon : PendingOrdersInactiveIcon}></img>
                        <div className="button-text">
                            Pending {orderPluralCaption} <br />
                            <b>{pendingCount}</b>
                        </div>
                    </Button>
                }
                {
                    !props.showPending && props.showPendingPlaceholder &&
                    <div className='button-replacement'>
                    </div>
                }
                {
                    !props.hidePastDue &&
                    <Button onClick={() => navigate(props.url + '?pastDue=true')}
                        className={pastDueCount > 0 ? "past-due-orders-button" : ""}>
                        <img src={pastDueCount > 0 ? PastDueOrdersActiveIcon : PastDueOrdersInactiveIcon}></img>
                        <div className="button-text">
                            Past Due {orderPluralCaption}<br />
                            <b>{pastDueCount}</b>
                        </div>
                    </Button>
                }
            </>
        </div>
    )
} 
